import { expertise } from '@/data/expertise';
import { Container, SectionHeading } from '@/components/common/SectionHeading';
import styles from './Expertise.module.css';

export function Expertise() {
  return (
    <section id="expertise" className="section" aria-labelledby="expertise-heading">
      <Container>
        <SectionHeading
          id="expertise-heading"
          eyebrow="Expertise"
          title="Where I create the most value"
          description="Practical strengths grounded in the roles and technologies already represented in my experience."
        />
        <div className={styles.grid}>
          {expertise.map((item, index) => (
            <article key={item.id} className={styles.card}>
              <span className={styles.index} aria-hidden="true">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className={styles.title}>{item.title}</h3>
              <p className={styles.description}>{item.description}</p>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}
